import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import { Combo2Service, ExcelService, ReportService,PurchaseReportService } from "../../../services/index";
import { GrnService } from "../../../services/grn.service";

@Component({
  selector: "sales-Plan-MasterReport",
  templateUrl: "./monthRgrnReport.html"
})
export class monthRgrnReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  typeCtrl: FormControl = new FormControl();
  orderCtrl: FormControl = new FormControl();
  isLoadMask: Promise<any>;

  loadingIndicator: boolean;
  gridOptions: any;
  seasonList = [];
  seasonyearList = [];
  colorList = [];
  orderList = [];
  menu: any;
  seasonfinList = [];
  backbutton: boolean;
  showIncharger: string;
  showAgent: string;
  showLine: string;
  typeList = [];
  exceldata: any;
  ord_date_change: boolean = false;
  totalseason_target: string;
  seasonShow: string;
  date_id: any;
  year_id: any;
  filter = {
    fin_id: "",
    groupby: "month_wise",
    from_date: "",
    to_date: "",
    month: "",
    grn_id: "",
    date_entry: false,
    style: ""

  };

  columns = [];
  toggleCol = [];
  finyearList: any;

  constructor(
    private salesPlan: PurchaseReportService,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    public datePipe: DatePipe,
    private excelService: ExcelService
  ) {

    this.colorList = ["lightcyan", "bisque", "lightblue", "lightgoldenrodyellow", "thistle", "floralwhite", "#cc97ca", "#f2cd75", "#cec4aa", "lightblue"];
  
   
    this.backbutton = false;
    this.loadingIndicator = true;
  }

  ngOnInit(): void {

    this.columns = [];
    this.finyearCombo();
    this.loadSeasonList();

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: []
    };

    this.toggleCol = Object.assign({}, this.columns);
  }

  finyearCombo() {
    this.combo2Service.finyearCombo().then((res: any) => {
      this.finyearList = res.data;
      this.finyearCtrl.setValue(res.data[0].fin_id);
      this.year_id = res.data[0].fin_id;
    });


  }
  changeDateRange(){
  this.filter.date_entry = true;
  }
  onSelectFinyear(id) {
    this.year_id = id;
    let seasonfinList = _.filter(this.finyearList, { fin_id: id });
    this.seasonfinList = seasonfinList;
    this.seasonCtrl.setValue(
      this.seasonList[this.seasonList["length"] - 1].season_id
    );
    this.onSelectdate('ALL');
  }
  displayFinyear(comboType: string, id: number) {

    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

 
  loadSeasonList() {
    let that = this;
    that.reportService.getBrandNewSeason(this.filter).then(function (res) {
      that.seasonList = res;
      that.seasonyearList = res;
      that.onSelectdate('ALL');
      that.allseason();
      that.seasonCtrl.setValue(res[res["length"] - 1].season_id);
      that.grnMonthwiseList();
    });
  }

  allseason() {
    let fin_id = parseInt(this.filter.fin_id);

    this.seasonList.forEach(() => {
      let seasonAll = {
        season: "ALL",
        season_id: this.seasonList[this.seasonList["length"] - 1].season_id + 1,
        fin_id: fin_id,
      };
      if (fin_id > 0) {
        this.seasonList.push(seasonAll);
      }
      fin_id = fin_id - 1;
    });


  }



  onSelectdate(type) {
    if (type == "ALL") {

      let id = this.year_id;
      let data = this.seasonfinList;
      let obj_data = data.filter(o => o.fin_id == id);
      let obj = obj_data.filter(o => o.season !== type);
      this.filter.from_date = obj[0].start_date;
      this.filter.to_date = obj[0].end_date;
  
    }
    this.filter.date_entry = false;
  }
  applyFilter(): void {

 

     

    this.grnMonthwiseList();
  }
  onCellClick(event) {
  
    let row = event.row;
    this.backbutton = false;
   
 
    if (this.filter.groupby == "date_wise") {
      this.filter.style = row.shirt_style;
      this.filter.groupby = "variety_wise";
    }
    else if (this.filter.groupby == "month_wise") {  
      this.filter.month = row.month_date;
      this.filter.groupby = "date_wise";
    
    }


    this.grnMonthwiseList();
  }
  onbackbutton(groupby) {
 
   
    if (groupby == "variety_wise") {
      this.backbutton = true;
      this.filter.groupby = "date_wise";
      this.filter.style = '';
    }

    else if (groupby == "date_wise") {
      this.backbutton = false;
      this.filter.groupby = "month_wise";
      this.filter.month = "";
    }
   
    this.grnMonthwiseList();
  }
  grnMonthwiseList(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
   
    let params = {
      filter: JSON.stringify(this.filter)
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
      data: []
    };

    this.isLoadMask = this.salesPlan
      .getmonthRgrnreport(params)
      .then(function (res: any) {
        that.orderList = res.data;
        that.gridOptions = {
          columns: res.columns,
          data: res.data,
          loading: false
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }


  getData(columns, data) {
    let cols = columns;
    let rows = [],
      row,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno
      };
      for (let j = 1; j < clen; j++) {
        let prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  ngOnDestroy() {
    this.salesPlan;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/woreports/monthRgrnReport.ts